import React from 'react';
import DashboardLayout from '../DashboardLayout';

const ProductOrder = () => {
    return (
        <DashboardLayout>
           product order list
        </DashboardLayout>
    );
};

export default ProductOrder;